import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=7a84b2c4&"
import script from "./ProjectsTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports